import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=183ca851&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183ca851')) {
      api.createRecord('183ca851', component.options)
    } else {
      api.reload('183ca851', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=183ca851&", function () {
      api.rerender('183ca851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Forms/Fields/Checkbox.vue"
export default component.exports